import React, { useCallback, useEffect, useLayoutEffect, useRef } from 'react'
import Package from '../Package'
import useDetectDevice from '../../../../../hooks/useDetectDevice'
import { isStagedWithCortPackage } from '../../../../../helpers/packages'

function DesktopPackages({ packages, onInfoModalShow, onPackageClicked, isPackageActive, minimal }) {
  const scrollRef = useRef(null)

  const { isMobile, isMobileLandscape } = useDetectDevice()

  useEffect(() => {
    const handleWheel = (event) => {
      if (scrollRef.current) {
        // Allow horizontal scroll using both the wheel (for mouse users) and the touchpad (deltaX for touchpad gestures)
        event.preventDefault()
        // If horizontal scroll (touchpad)
        if (Math.abs(event.deltaX) > 0) {
          scrollRef.current.scrollLeft += event.deltaX
        } else {
          // Otherwise, convert vertical scroll (mouse wheel) to horizontal scroll
          scrollRef.current.scrollLeft += event.deltaY
        }
      }
    }

    const scrollElement = scrollRef.current
    scrollElement.addEventListener('wheel', handleWheel)

    return () => {
      scrollElement.removeEventListener('wheel', handleWheel)
    }
  }, [])

  const recalculateWidth = useCallback(() => {
    setTimeout(() => {
      if (scrollRef && scrollRef.current) {
        const pills = scrollRef.current.querySelectorAll('.pill')

        const largetPillWidth = Math.max(
          ...Array.from(pills).map((p) => {
            return p.getBoundingClientRect().width
          }),
        )
        scrollRef.current.querySelectorAll('.pill').forEach((e) => {
          e.style.width = `${largetPillWidth}px`
        })
      }
    }, 10)
  }, [scrollRef])

  useEffect(() => {
    recalculateWidth()
  }, [packages, recalculateWidth])

  useEffect(() => {
    recalculateWidth()
  }, [isMobile, isMobileLandscape, recalculateWidth])

  // useLayoutEffect(() => {
  //   if (scrollRef && scrollRef.current) {
  //     const pills = scrollRef.current.querySelectorAll('.pill')

  //     const largetPillWidth = Math.max(
  //       ...Array.from(pills).map((p) => {
  //         return p.getBoundingClientRect().width;
  //       }),
  //     );
  //     scrollRef.current.querySelectorAll('.pill').forEach((e) => {
  //       e.style.width = `${largetPillWidth}px`
  //     })
  //   }
  // }, [scrollRef, packages])

  const activePackageIndex = packages.findIndex((p) => isPackageActive(p))

  const packs = packages.map((p, i) => ({
    ...p,
    border: !(i === activePackageIndex - 1 || i === activePackageIndex),
  }))

  return (
    <div className="hidden lg:flex rounded-[6px]  max-w-[calc(100vw-48px-var(--sidebar-shown-width)-250px-24px)] h-[52px] overflow-y-hidden relative">
      <div className="max-w-full flex overflow-x-auto h-[100px]" ref={scrollRef}>
        {packs.map((pack, index) => (
          <Package
            minimal={minimal}
            key={pack.id + index}
            className={`${
              minimal ? 'h-[40px]' : 'h-[52px]'
            } relative pill w-max ${isStagedWithCortPackage(pack) ? '!h-[32px] rounded-[16px]' : ' first:rounded-l-[6px] last:rounded-r-[6px]'}`}
            onInfoModalShow={() => onInfoModalShow(pack)}
            onClick={() => onPackageClicked(pack)}
            pack={pack}
            isActive={isPackageActive(pack)}
          />
        ))}
      </div>
    </div>
  )
}

export default DesktopPackages
